import React from 'react';
import PreviewModal from '~/src/components/Modal/PreviewModal';

interface BillingCyclePreviewModalProps {
  previewData: any;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

export const BillingCyclePreviewModal = ({
  previewData,
  onCancel,
  onConfirm,
  isProcessing = false,
}: BillingCyclePreviewModalProps) => {
  const invoiceData = previewData?.preview?.data;
  const { immediate_invoice, recurring_invoice } = invoiceData || {};

  return (
    <PreviewModal
      title="Confirm Billing Cycle Change"
      onCancel={onCancel}
      onConfirm={onConfirm}
      isProcessing={isProcessing}
      confirmText="Confirm Change"
      cancelText="Cancel"
      beforeAfterState={{
        currentLabel: 'Current Billing Cycle',
        newLabel: 'New Billing Cycle',
        currentValue: previewData?.current_billing_cycle || '',
        newValue: previewData?.new_billing_cycle || '',
      }}
      invoiceSection={{
        immediateInvoice: immediate_invoice,
        recurringInvoice: recurring_invoice,
      }}
      importantNotes={[
        'Any changes to the billing cycle will be applied to all Clio products on your subscription.',
        'Billing cycle changes may result in prorated charges or credits.',
      ]}
    />
  );
};
